<template>
  <v-container>
    <div>
      <template>
        <v-dialog
          v-model="dialog"
          width="500"
          @click:outside="closeModal"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                {{ $t("Create a Group") }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="black--text">
              <v-row class="mt-5">
                <v-col cols="12">
                  <div class="d-flex justify-space-between">
                    <v-text-field
                      type="text"
                      outlined
                      dense
                      placeholder="Type the group name here"
                      v-model="newGroupName"
                    >
                    </v-text-field>
                    <v-btn
                      @click="onNewGroupCreate"
                      right
                      color="primary"
                      class="ml-2 py-5 px-5"
                    >
                      Create New
                    </v-btn>
                  </div>

                  <div class="custom-line"><span>or</span></div>

                  <label class="">Choose from existing Groups</label>
                  <v-radio-group v-model="existingGroup">
                    <v-radio
                      v-for="group in groups"
                      :key="group.id"
                      :label="group.name"
                      :value="group.id"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-card-actions class="mt-10" style="padding-right: 0">
                <v-spacer></v-spacer>
                <v-btn
                  @click="closeModal"
                  outlined
                  class="mr-2 px-5"
                  right
                  height="44"
                  depressed
                  color="primary"
                >
                  {{ $t("cancel") }}
                </v-btn>
                <v-btn
                  @click="onConfirm"
                  right
                  height="44"
                  color="primary"
                  class="px-5"
                >
                  Confirm selection
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";

export default {
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  data() {
    return {
      existingGroup: null,
      newGroupName: "",
    };
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    groups: {
      required: true,
      type: Array,
    },
  },
  watch: {
    /* eslint-disable */
    groups(nV, oV) {
      if (
        !this.existingGroup &&
        Array.isArray(this.groups) &&
        this.groups.length > 0
      ) {
        this.existingGroup = this.groups[0].id;
      }
      console.log(nV, "nv");
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },
    onConfirm() {
      if (!this.existingGroup) {
        this.$notify({
          title: "Please select a group",
          type: "error",
        });
        return;
      }
      this.$emit("group:selected", this.existingGroup);
    },
    onNewGroupCreate() {
      this.$emit("new-group:create", this.newGroupName);
    },
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
.border {
  border: 2px solid;
  border-color: #dae1ec;
}

.v-tab {
  text-transform: none !important;
}

.custom-line {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #d2d2d2;
  line-height: 0.1em;
  margin: 10px 0 20px;
}

.custom-line span {
  background: #fff;
  padding: 0 10px;
}
</style>
